import { StickyModalFooter } from '@app/components/various/Modal';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '../various/Button';
import { Form, TextareaField } from '../various/Form';

interface SurveyCommentFormValue {
  comment: string;
}
interface Props {
  onCancel: VoidFunction;
  onSubmit: (comment: string) => void;
  isLoading?: boolean;
}
export const SurveyOpinionForm = ({ onCancel, onSubmit, isLoading = false }: Props) => {
  const { t } = useTranslation(['common', 'onboarding']);
  const defaultValues = {
    comment: '',
  };

  const formMethods = useForm<SurveyCommentFormValue>({ defaultValues });
  const { register } = formMethods;

  const handleSubmit = (value: SurveyCommentFormValue) => {
    onSubmit(value.comment);
  };

  return (
    <Form id="survey-form" formMethods={formMethods} onSubmit={handleSubmit} className="space-y-6">
      <TextareaField {...register('comment')} maxLength={1000} />
      <StickyModalFooter>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" color="secondary" onClick={onCancel}>
            {t('onboarding:skip')}
          </Button>
          <Button color="primary" type="submit" isLoading={isLoading}>
            {t('common:submit')}
          </Button>
        </div>
      </StickyModalFooter>
    </Form>
  );
};
